import { eventInitials, tileColor } from '../data/format'
import styles from './EventCard.module.css'

/** Organizer-flyer fallback: a typed tile with the track's initials, per the design's note "no
 *  flyer posted -> a typed tile so the grid never has holes." Shared by every card shape. */
export function NoFlyerTile({ id, name, raceType, caption }: { id: number; name: string; raceType: string; caption?: string }) {
  return (
    <div className={styles.noFlyerTile} style={{ background: tileColor(id) }}>
      <span className={styles.noFlyerType}>{raceTypeLabel(raceType)}</span>
      <span className={styles.noFlyerInitials}>{eventInitials(name)}</span>
      {caption ? <span className={styles.noFlyerCaption}>{caption}</span> : null}
    </div>
  )
}

function raceTypeLabel(raceType: string): string {
  switch (raceType) {
    case 'offroad':
      return 'Off-road'
    case 'onroad':
      return 'On-road'
    case 'oval':
      return 'Oval'
    default:
      return 'R/C Racing'
  }
}
